<div class="modal-header">
    <h4>{{ medarbejder.init + ' - ' + title }}</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <div class="table__viewport">
        <table class="table table-hover table-striped table-sm table-frame__body" >
            <thead>
                <tr>
                    <th>Dato</th>
                    <th>Beskrivelse</th>
                    <th class="text-end">Timer</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let ikrt of IkkeKunderelateretTidViewList$ | async;">
                    <td>{{ikrt.dato | date:'dd-MM-yyyy'}}</td>
                    <td>{{ikrt.beskrivelse}}</td>
                    <td class="text-end">{{ikrt.timer | time}}</td>
                </tr>
            </tbody>

            <tfoot>
                <tr>
                    <th>Total</th>
                    <th></th>
                    <th class="text-end">{{ totalHours | time}}</th>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
